// extracted by mini-css-extract-plugin
export default {"stage":"style_stage__RifOP","stageButton":"style_stageButton__wIAHL"};